import {
  PAGE_NOT_FOUND,
  CONTATTI,
  FAQ,
  INFORMATIVA_TRATTAMENTO_DATI,
  LINGUA_INGLESE,
  NESSUN_OSPEDALE_TITLE,
  NESSUN_OSPEDALE_MESSAGE,
  INSTALLAZIONE_HEADER,
  INSTALLAZIONE_ISTRUZIONI1,
  INSTALLAZIONE_ISTRUZIONI2,
  INSTALLAZIONE_ISTRUZIONI3,
  INSTALLAZIONE_ISTRUZIONI4,
  EMPTY_MESSAGE,
  SELECT_PLACEHOLDER,
  INPUT_PLACEHOLDER,
  AZIENDA_SANITARIA_LABEL,
  AZIENDA_SANITARIA_MESSAGE,
  AZIENDA_SANITARIA_PLACEHOLDER,
  STRUTTURA_SANITARIA_LABEL,
  STRUTTURA_SANITARIA_MESSAGE,
  STRUTTURA_SANITARIA_PLACEHOLDER,
  ID_PAZIENTE_LABEL,
  ID_PAZIENTE_MESSAGE,
  ID_PAZIENTE_PLACEHOLDER,
  ACCEDI,
  RESET,
  ACQUISIZIONE_FOTOCAMERA,
  SPINNING_INTERVENTO,
  QR_CODE_ERRATO_TITLE,
  QR_CODE_ERRATO_MESSAGE,
  INTERVENTO_204_TITLE,
  INTERVENTO_204_MESSAGE,
  LEGENDA,
  NON_INIZIATO_LABEL,
  IN_CORSO_LABEL,
  CONCLUSO_LABEL,
  ID_PAZIENTE_TITLE,
  DATA_INTERVENTO_TITLE,
  STATO_NON_DISPONIBILE,
  STATO_INTERVENTO_PIANIFICATO,
  STATO_IN_BLOCCO_OPERATORIO,
  STATO_INTERVENTO_IN_CORSO,
  STATO_INTERVENTO_POST_OPERATORIO,
  STATO_INTERVENTO_TERMINATO,
  INGRESSO_BLOCCO_OPERATORIO_LABEL,
  INGRESSO_SALA_OPERATORIA_LABEL,
  USCITA_SALA_OPERATORIA_LABEL,
  USCITA_BLOCCO_OPERATORIO_LABEL,
  LAST_UPDATE_LABEL,
  INTERVENTO_NUOVI_DATI_TITLE,
  INTERVENTO_NUOVI_DATI_MESSAGE,
  SERVIZIO_NON_DISPONIBILE_TITLE,
  SERVIZIO_NON_DISPONIBILE_MESSAGE,
} from "../modules/language";

const common = {
  [PAGE_NOT_FOUND]: "Pagina non trovata!",
  [CONTATTI]: "Contatti",
  [FAQ]: "FAQ",
  [INFORMATIVA_TRATTAMENTO_DATI]: "Informativa sul trattamento dei dati",
  [LINGUA_INGLESE]: "English",
};

const notification = {
  [NESSUN_OSPEDALE_TITLE]: "Nessuna Azienda Sanitaria/Ospedaliera trovata",
  [NESSUN_OSPEDALE_MESSAGE]: "Si è verificato un errore durante il recupero delle Aziende Santitarie/Ospedaliere",
};

const installazioneApple = {
  [INSTALLAZIONE_HEADER]: "Installazione",
  [INSTALLAZIONE_ISTRUZIONI1]: "Tocca",
  [INSTALLAZIONE_ISTRUZIONI2]: "e poi ",
  [INSTALLAZIONE_ISTRUZIONI3]: "'Aggiungi a Home'",
  [INSTALLAZIONE_ISTRUZIONI4]: "per installare la App sul tuo dispositivo",
};

const formRicerca = {
  [EMPTY_MESSAGE]: "Nessun risultato",
  [SELECT_PLACEHOLDER]: "Seleziona...",
  [INPUT_PLACEHOLDER]: "Inserisci...",
  [AZIENDA_SANITARIA_LABEL]: "Seleziona l'Azienda Sanitaria/Ospedaliera",
  [AZIENDA_SANITARIA_MESSAGE]: "Selezionare l'azienda sanitaria!",
  [AZIENDA_SANITARIA_PLACEHOLDER]: "Azienda sanitaria/ospedaliera",
  [STRUTTURA_SANITARIA_LABEL]: "Seleziona la Struttura",
  [STRUTTURA_SANITARIA_MESSAGE]: "Selezionare la struttura!",
  [STRUTTURA_SANITARIA_PLACEHOLDER]: "Struttura",
  [ID_PAZIENTE_LABEL]: "Inserisci il codice identificativo ricevuto:",
  [ID_PAZIENTE_MESSAGE]: "Inserire il codice identificativo!",
  [ID_PAZIENTE_PLACEHOLDER]: "Codice identificativo ricevuto",
  [ACCEDI]: "Accedi",
  [RESET]: "Pulisci i dati",
  [ACQUISIZIONE_FOTOCAMERA]: "Acquisisci da fotocamera",
  [SPINNING_INTERVENTO]: "Recupero informazioni per il paziente indicato",
  [QR_CODE_ERRATO_TITLE]: "QR Code non valido",
  [QR_CODE_ERRATO_MESSAGE]: "Non è stato possibile recuperare le informazioni dal qr code scansionato",
  [INTERVENTO_204_TITLE]: "Nessuna informazione disponibile",
  [INTERVENTO_204_MESSAGE]: "Per la struttura selezionata e il codice identificativo inserito non è visualizzabile alcuna informazione", //prettier-ignore
  [INTERVENTO_NUOVI_DATI_TITLE]: "Nuovo aggiornamento",
  [INTERVENTO_NUOVI_DATI_MESSAGE]: "Dalle informazioni presenti nel sistema si evidenzia un nuovo aggiornamento",
  [SERVIZIO_NON_DISPONIBILE_TITLE]: "Servizio momentaneamente non disponibile",
  [SERVIZIO_NON_DISPONIBILE_MESSAGE]: "Riprovare fra qualche minuto",
};

const monitora = {
  [LEGENDA]: "Legenda",
  [NON_INIZIATO_LABEL]: "non ancora iniziato",
  [IN_CORSO_LABEL]: "in corso",
  [CONCLUSO_LABEL]: "concluso",
  [ID_PAZIENTE_TITLE]: "Identificativo paziente",
  [DATA_INTERVENTO_TITLE]: "Data intervento",
  [STATO_NON_DISPONIBILE]: "Informazioni non disponibili",
  [STATO_INTERVENTO_PIANIFICATO]: "Intervento pianificato per ",
  [STATO_IN_BLOCCO_OPERATORIO]: "In blocco operatorio",
  [STATO_INTERVENTO_IN_CORSO]: "Intervento in corso",
  [STATO_INTERVENTO_POST_OPERATORIO]: "Post operatorio",
  [STATO_INTERVENTO_TERMINATO]: "Intervento terminato",
  [INGRESSO_BLOCCO_OPERATORIO_LABEL]: "Ingresso blocco operatorio",
  [INGRESSO_SALA_OPERATORIA_LABEL]: "Ingresso sala operatoria",
  [USCITA_SALA_OPERATORIA_LABEL]: "Uscita sala operatoria",
  [USCITA_BLOCCO_OPERATORIO_LABEL]: "Uscita blocco operatorio",
  [LAST_UPDATE_LABEL]: "Ultimo aggiornamento:",
};

const it = {
  ...common,
  ...notification,
  ...installazioneApple,
  ...formRicerca,
  ...monitora,
};

export { it };
